var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"DgSpacer contentModule",class:_vm.elmClasses,attrs:{"data-dev-name":'DgSpacer • ' + _vm._size}},[_c('div',{staticClass:"DgSpacer__inner contentModule__inner",class:_vm.innerElmClasses},[_c('div',{staticClass:"DgSpacer__content contentModule__content fontStyle--m",class:_vm.contentElmClasses})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }